import { render, staticRenderFns } from "./A2ComparisonModal.vue?vue&type=template&id=5389e0d3&"
import script from "./A2ComparisonModal.vue?vue&type=script&lang=js&"
export * from "./A2ComparisonModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports